<script setup lang="ts">
// Shown only for the brief window before `getWindowKind()` resolves and
// `App.vue` replaces the route with the actual splash or editor page.
</script>

<template>
  <div
    class="grid h-full place-items-center text-sm"
    style="color: var(--text-muted); font-family: var(--font-ui)"
  >
    Loading…
  </div>
</template>
